import { DELETE_CLIENT } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_CLIENT.LOAD:
      return {
        ...state,
        loading: true
      };
    case DELETE_CLIENT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case DELETE_CLIENT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
